// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2D-xV","filesListContainer":"PosDisputesFiles_filesListContainer__3e62F","filesButton":"PosDisputesFiles_filesButton__1EL_b"};